export const FnArr: Array<{ [s: string]: string }> = [
    { name: 'login', method: 'post', prefix: "user", path: 'login' },
    { name: 'wxLogin', method: 'post', prefix: "user", path: 'wx_login' },
    { name: 'googleLogin', method: 'post', prefix: "user", path: 'google_login' },
    { name: 'register', method: 'post', prefix: "user", path: 'register' },
    { name: 'getCaptcha', method: 'post', prefix: 'verification_code', path: 'get_email_verification_code' },
    { name: 'getToken', method: 'post', prefix: "user", path: 'get_access_token' },
    { name: 'exchangeWasmToken', method: 'post', prefix: "user", path: 'exchange_wasm_token' },
    { name: 'tokenLogin', method: 'post', prefix: "user", path: 'token_login' },
];
